import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";
import { Menu } from "../../context/MenuContext";
import { WindowSize } from "../../context/WindowContext";
import { useCounts } from "../../context/CountsContext";
import "./bars.css";
import { NavLink } from "react-router-dom";
import { links } from "./NavLink";

export default function SideBar() {
  const { isOpen, setIsOpen } = useContext(Menu);
  const { windowSize } = useContext(WindowSize);
  const { counts } = useCounts();
  const isMobile = windowSize < 768;
  const expanded = isOpen;

  return (
    <>
      {isMobile && (
        <div
          className={`sidebar-overlay${expanded ? " show" : ""}`}
          onClick={() => setIsOpen(false)}
        />
      )}

      <div
        className="side-bar pt-2"
        style={{
          position: isMobile ? "fixed" : "sticky",
          right: isMobile ? (expanded ? 0 : "-100%") : 0,
          width: expanded ? "220px" : isMobile ? "220px" : "64px",
          minWidth: expanded ? "220px" : isMobile ? "220px" : "64px",
        }}
      >
        {links.map((link, key) => {
          const count = counts[link.path];
          return (
            <NavLink
              key={key}
              to={link.path}
              className="side-bar-link"
              onClick={() => isMobile && setIsOpen(false)}
            >
              <span className="sb-icon">
                <FontAwesomeIcon icon={link.icon} />
              </span>
              {expanded && (
                <>
                  <span className="sb-label">{link.name}</span>
                  {count !== null && count !== undefined && (
                    <span className="sb-count">{count}</span>
                  )}
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </>
  );
}
